<template>
  <v-chip
    label
    small
  >
    {{ title }}
  </v-chip>
</template>

<script>
import auth from "../../auth";
export default {
  props: ["value"],
  computed: {
    title() {
      const role = auth.rolesDict.find(r => r.value === this.value);
      return role ? role.text : "";
    },
  },
};
</script>